module.exports = __webpack_public_path__ + "img/paymentSuccessful.f39fe532.png";